import { defineStore } from "pinia";
import { deleteGalleryImages, getGalleryImages, updateImageInfo, uploadGalleryImage } from "../services/gallery";
import type { Image } from "../services/gallery/types";

export const useGalleryStore = defineStore("gallery", {
    state: () => ({
        galleryImages: [] as Image[],
    }),
    getters: {
        getGalleryImages(state) {
            return state.galleryImages;
        },
    },
    actions: {
        async dispatchUploadGalleryImages(formData, config) {
            return await uploadGalleryImage(formData, config);
        },

        async dispatchGetGalleryImages(filter:string|null = '') {
            const response = await getGalleryImages(filter);
            if (response) {
                this.galleryImages = response.data.data;
            }
        },

        async dispatchUpdateImageInfo(imageId: number, formData: Image) {
            return await updateImageInfo(imageId, formData);
        },

        async dispatchDeleteGalleryImage(formData) {
            return await deleteGalleryImages(formData);
        },
    },
});
